import { render, staticRenderFns } from "./phiFormulaInnerInput.vue?vue&type=template&id=99a07a2a&"
import script from "./phiFormulaInnerInput.vue?vue&type=script&lang=ts&"
export * from "./phiFormulaInnerInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports